<template>
  <div class="row">
    <div class="col-md-3 col-lg-2">
      <MemberProfilesNav :tabs="setting_tabs" />
    </div>
    <div class="col-md-8 col-sm-9 col-lg-10 border-left pl-lg-30 setting_wrapper settings_panel">
      <div class="d-sm-flex justify-content-between">
        <div class="mb-10">
          <h5
            class="setting-title"
            data-testid="global-todos-page-heading"
          >Global to-dos</h5>
          <p
            class="text-muted"
            style="margin-right: 10ex"
            data-testid="global-todos-page-description"
          >
            Global to-dos can be added to any project.
            Once added to a project, all members of the project can track time to them,
            and they cannot be marked as complete so they'll always be visible.
            Data from these shared to-dos can be viewed across projects in 'Time & activity' report.
          </p>
        </div>

        <div class="d-flex d-sm-block">
          <AppButton
            id="new-global-todo"
            class="flex-1"
            type="primary"
            data-testid="add-global-todo-button"
            @click="onShowNewDialog"
          >
            + Add a global to-do
          </AppButton>
        </div>
      </div>

      <AppTableLoading
        v-if="loading"
        :columns="4"
      ></AppTableLoading>

      <GlobalTodosTable
        v-else
        :show-loading="loading"
        :global-todos="global_todos"
        @open-edit-dialog="onShowEditDialog"
        @open-delete-dialog="onShowDeleteDialog"
      />
    </div>

    <GlobalTodoFormDialog
      v-if="showGlobalTodoDialog"
      :organization-id="organization.id"
      :global-todo="editingGlobalTodo"
      @close="handleDialogClose"
      @save-success="handleDialogClose"
    />
  </div>
</template>

<script>
// Inertia helpers/utils
import { InertiaFlashWatcher, InertiaLoadingWatcher } from '~/utils/inertia';
// Components
import GlobalTodosTable from '~/components/global_todos/GlobalTodosTable.vue';
import GlobalTodoFormDialog from '~/components/global_todos/GlobalTodoFormDialog.vue';
import MemberProfilesNav from '~/components/settings/MemberProfilesNav.vue';
import { GlobalTodosResource } from '~/resources';

export default {
  name: 'GlobalTodos',
  components: {
    MemberProfilesNav,
    GlobalTodosTable,
    GlobalTodoFormDialog,
  },
  mixins: [InertiaFlashWatcher, InertiaLoadingWatcher],
  props: {
    global_todos: {
      type: Array,
      required: true,
    },
    organization: {
      type: Object,
      required: true,
    },
    setting_tabs: {
      type: Array,
      required: true,
    },
    base_url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showGlobalTodoDialog: false,
      editingGlobalTodo: null,
    };
  },
  computed: {
    isEmpty() {
      return (this.global_todos || []).length === 0;
    },
  },
  mounted() {
  },
  methods: {
    onShowNewDialog() {
      this.editingGlobalTodo = null;
      this.showGlobalTodoDialog = true;
    },
    onShowEditDialog(globalTodo) {
      this.loadGlobalTodoEdit(globalTodo)
    },
    onShowDeleteDialog(globalTodo) {
      AjaxDialog.run(this.base_url.replace('__ID__', `${globalTodo.id}`));
    },
    handleDialogClose() {
      this.showGlobalTodoDialog = false;
      this.editingGlobalTodo = null;
    },
    loadGlobalTodoEdit(globalTodo) {
      GlobalTodosResource.edit({
        organizationId: this.organization.id,
        id: globalTodo.id,
      }).then(response => {
        this.editingGlobalTodo = response;
        this.showGlobalTodoDialog = true
      }).catch(() => {
        this.$appMessage('Failed to load global to-do data');
      });
    }
  },
};
</script>
